export default ({ iso1, iso2 }) => {
  if (!iso1 || !iso2) return iso1 || iso2

  const date1 = new Date(iso1).getTime()
  const date2 = new Date(iso2).getTime()

  if (date1 > date2) {
    return iso1
  }
  if (date1 < date2) {
    return iso2
  }
  return iso2
}
